import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material';
import { DisclaimerComponent } from './disclaimer.component';

@NgModule({
  entryComponents: [
    DisclaimerComponent
  ],
  imports: [
    CommonModule,
    MatIconModule
  ],
  declarations: [
    DisclaimerComponent
  ],
  exports: [
    DisclaimerComponent
  ]
})
export class DisclaimerModule {}
